import { render, staticRenderFns } from "./target-weight-ruler.vue?vue&type=template&id=a33a449a&scoped=true&"
import script from "./target-weight-ruler.vue?vue&type=script&lang=js&"
export * from "./target-weight-ruler.vue?vue&type=script&lang=js&"
import style0 from "./target-weight-ruler.vue?vue&type=style&index=0&id=a33a449a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33a449a",
  null
  
)

export default component.exports